export interface Item {
  id: string;
  type: symbol;
}

export default {
  GROUP: Symbol('group'),
  SECURITY: Symbol('security'),
};
